import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IProduct } from 'src/app/models/products/product';

export type OutputAssetsSubTab = 'range' | 'ev';

@Component({
    selector: 'app-step-output-assets',
    templateUrl: './step-output-assets.component.html',
    styleUrls: ['./step-output-assets.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class StepOutputAssetsComponent {
  @Input() product!: IProduct;
  @Input() colPerScreen = 3;
  @Input() editCallback!: (data: any) => void;

  activeSubTab: OutputAssetsSubTab = 'range';
  evActivated = false;
  bucketCounts: { range: number | null; ev: number | null } = { range: null, ev: null };

  onSubTabChanged(subTab: OutputAssetsSubTab): void {
    this.activeSubTab = subTab;
    if (subTab === 'ev') this.evActivated = true;
  }

  onBucketLoaded(subTab: OutputAssetsSubTab, event: { count: number }): void {
    this.bucketCounts = { ...this.bucketCounts, [subTab]: event.count };
    if (subTab === 'range' && event.count === 0 && this.bucketCounts.ev !== 0) {
      this.activeSubTab = 'ev';
      this.evActivated = true;
    }
  }
}
